module.exports = {"asl.heading":"ASL"}


//////////////////
// WEBPACK FOOTER
// ./src/components/i18n/locales/ar.json
// module id = 709
// module chunks = 0